import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const BANNER =
  "https://customer-assets-0z36b82j.emergentagent.net/job_pmo-ai-cyber/artifacts/916e58321b56f9e1_Aicendor_%20Global%20AI%20Governance%20Banner.webp";

export default function BrandPanorama() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);

  return (
    <section ref={ref} className="relative pb-10 lg:pb-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <div data-testid="brand-panorama" className="group relative">
            <div className="absolute inset-0 translate-x-3 translate-y-3 border border-gold/30" aria-hidden="true" />
            <div className="relative overflow-hidden border border-gold/40">
              <motion.img
                src={BANNER}
                alt="AiCendor — global AI governance, cybersecurity, enterprise risk and PMO transformation"
                data-testid="brand-panorama-image"
                style={{ y }}
                className="img-treated aspect-video w-full scale-[1.16] object-cover sm:aspect-[8/3]"
              />
              <div
                className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/55 via-transparent to-ink/25"
                aria-hidden="true"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
